import {gsap} from 'gsap'
import {ScrollTrigger} from 'gsap/ScrollTrigger'
import {ScrollSmoother} from 'gsap/ScrollSmoother'
import {SplitText} from 'gsap/SplitText'
import 'is-in-viewport'
import {onScroll} from './transition'

function allElementsExist() {
  for (const c of arguments) {
    if (!document.querySelector(c)) {
      return false
    }
  }
  return true
}

function registerRefreshOnResize() {
  let bodyHeight = null
  const resizeObserver = new ResizeObserver((entries) => {
    for (const entry of entries) {
      const newBodyHeight = entry.contentRect.height
      if (bodyHeight === null) {
        bodyHeight = newBodyHeight
      } else if (Math.abs(bodyHeight - newBodyHeight) > 20) {
        console.log('New body height', newBodyHeight, `(${newBodyHeight - bodyHeight})`)
        bodyHeight = newBodyHeight
        ScrollTrigger.refresh()
      }
    }
  })
  resizeObserver.observe(document.body)
}

gsap.registerPlugin(ScrollSmoother, ScrollTrigger, SplitText)

const scrollSmoother = ScrollSmoother.create({
  smooth: 2, // how long (in seconds) it takes to "catch up" to the native scroll position
  speed: 1,
  // smoothTouch: 0.1, // much shorter smoothing time on touch devices (default is NO smoothing on touch devices)
  effects: true, // looks for data-speed and data-lag attributes on elements
  onUpdate: () => onScroll(),
  onStop: () => onScroll,
})

$(() => {
  // To fix page refresh bug breaking gsap
  window.scrollTo(0, 0)
  registerRefreshOnResize()

  for (const stickyContainer of document.querySelectorAll('.gsap-sticky-container')) {
    for (const sticky of stickyContainer.querySelectorAll('.gsap-sticky')) {
      ScrollTrigger.create({
        trigger: sticky,
        endTrigger: stickyContainer,
        pin: sticky,
        scrub: true,
        start: () => `top top+=${parseFloat(sticky.dataset.gsapTop)}`,
        end: () => `bottom top+=${sticky.offsetHeight + parseFloat(sticky.dataset.gsapTop)}`,
        // markers: true
      })
    }
  }

  // Hero
  if (allElementsExist('.block-heroBlock')) {
    const heroBlock = document.querySelector('.block-heroBlock')
    const heroPinContainer = heroBlock.querySelector('.hero-pin-container')
    const heroMediaOverlay = heroBlock.querySelector('.hero-media-overlay')

    const heroTextContainer = heroBlock.querySelector('.hero-text-container')
    const heroMedia = heroBlock.querySelector('.hero-media')
    const heroMediaContainer = heroBlock.querySelector('.hero-media-container')

    const heroLogoContainer = heroBlock.querySelector('.hero-logo-container')
    const heroLogo = heroBlock.querySelector('.hero-logo');

    const heroBuildingLabelsContainer = heroBlock.querySelector('.hero-building-labels-container')
    const heroBuildingLabelContainers = heroBlock.querySelectorAll('.hero-building-label-container')
    const heroBuildingLabelArrows = heroBlock.querySelectorAll('.hero-building-label-arrow')

    const adjacentBlock = $(heroBlock).closest('.block-container').nextAll('.block-container')[0]
    const computedStyle = window.getComputedStyle(adjacentBlock)
    const backgroundColor = computedStyle.getPropertyValue('background-color')

    const heroImageWidth = 2400;
    const heroImageHeight = 1350;

    function getHiddenPixels() {
      const innerWidth = window.innerWidth;
      const innerHeight = window.innerHeight;
      const scale = Math.max(innerWidth / heroImageWidth, innerHeight / heroImageHeight);
      return {
        x: heroImageWidth * scale - innerWidth,
        y: heroImageHeight * scale - innerHeight,
        scale: scale
      };
    }

    function centerImageAtPoint(targetX, targetY, scale, clamp = true) {
      const max = {
        x: (window.innerWidth * scale - window.innerWidth) / 2,
        y: (window.innerHeight * scale - window.innerHeight) / 2,
      };
      const originalImageWidth = heroImageWidth;
      const originalImageHeight = heroImageHeight;
      const hiddenPixels = getHiddenPixels();

      let x = (originalImageWidth / 2 - targetX) * scale * hiddenPixels.scale;
      if (clamp && Math.abs(x) > Math.abs(max.x)) {
        x = max.x * Math.sign(x);
      }


      let y = (originalImageHeight / 2 - targetY) * scale * hiddenPixels.scale;
      if (clamp && Math.abs(y) > Math.abs(max.y)) {
        y = max.y * Math.sign(y);
      }

      return {x, y};
    }

    const timelineTotalTime = 4;
    const sectionTime = 1 / timelineTotalTime;
    const timeline = gsap.timeline({
      scrollTrigger: {
        trigger: heroBlock,
        start: "top top",
        // end: () => `bottom+=${window.innerHeight} bottom`,
        end: () => `bottom bottom`,
        scrub: true,
        pin: heroPinContainer,
        // snap: [0, 1 * sectionTime, 1],
        snap: {
          snapTo: [0, 1 * sectionTime, 1], // Snap logic
          duration: { min: 2, max: 3 },  // Clamps snap speed based on velocity
          delay: 0,                       // Wait time after scroll stops before snapping
          ease: "power1.inOut"              // Smoothing for the snap move
        },
        invalidateOnRefresh: true,
        // markers: true,
      }
    })
    gsap.set(heroMedia, {
      scale: 1.1,
      x: () => centerImageAtPoint(1275, 647, 1.1).x,
      y: () => centerImageAtPoint(1275, 647, 1.1).y,
    })

    timeline.to(heroLogoContainer, {
      top: '4vh',
      duration: 1,
    }, '<')
    gsap.set(heroBuildingLabelContainers, {
      x: (i, element) => {
        // const heroMediaPoint = centerImageAtPoint(1275, 647, 1.1);
        // const point = centerImageAtPoint([879, 1385, 1663][i], 0, 1.1, false);

        const heroMediaPoint = centerImageAtPoint(1275, 647, 1.1);
        const point = centerImageAtPoint([964, 1460, 1739][i], 0, 1.1, false);

        return heroMediaPoint.x - point.x - element.getBoundingClientRect().width / 2;
      },
    })
    gsap.set(heroBuildingLabelArrows, {
      width: (i, element) => {
        if (i === 0) {
          return 180 * getHiddenPixels().scale;
        }
        return 0;
      },
      height: (i, element) => {
        return ([228, 334, 567][i] - centerImageAtPoint(1275, 647, 1.1).y) * getHiddenPixels().scale;
      },
    })
    timeline.to(heroBuildingLabelsContainer, {
      top: '38vh',
      height: (i, element) => {
        let height = 0;
        for (const e of element.querySelectorAll('.hero-building-label-container')) {
          const label = e.querySelector('.hero-building-label');
          const arrow = e.querySelector('.hero-building-label-arrow');
          height = Math.max(height, label.getBoundingClientRect().height + arrow.getBoundingClientRect().height + 2)
        }
        console.log('Building labels max height', height)
        return height;
      },
      duration: 1,
    }, '<')


    timeline.to(heroLogoContainer, {
      top: () => -heroLogo.getBoundingClientRect().height,
      duration: 1,
    }, )
    timeline.to(heroBuildingLabelsContainer, {
      top: '30vh',
      height: 0,
      duration: 1,
    }, '<')
    timeline.fromTo(heroMediaOverlay, {
      alpha: 0,
    }, {
      backgroundColor: backgroundColor,
      alpha: 0.4,
      duration: 1,
    }, '<')
    timeline.to(heroMedia, {
      scale: 1.5,
      x: () => centerImageAtPoint(1003, 878, 1.5).x,
      y: () => centerImageAtPoint(1003, 878, 1.5).y,
      transformOrigin: `center center`,
      duration: 1,
      ease: "power2.inOut",
    }, '<')


    gsap.set(heroTextContainer, {
      y: 42,
      opacity: 0,
    })
    timeline.to(heroTextContainer, {
      y: 0,
      opacity: 1,
      duration: 2,
    })


    const timeline2 = gsap.timeline({
      scrollTrigger: {
        trigger: heroBlock,
        start: "bottom bottom",
        end: () => `bottom+=${window.innerHeight} bottom`,
        scrub: true,
        invalidateOnRefresh: true,
        // markers: true,
      }
    })
    timeline2.to(heroMediaOverlay, {
      backgroundColor: backgroundColor,
      alpha: 1,
      duration: 1,
    })
    timeline2.to(heroMediaContainer,  {
      top: () => window.innerHeight,
      ease: 'none',
      duration: 1,
    }, '<' )
    timeline2.fromTo(adjacentBlock, {
      backgroundColor: backgroundColor,
      alpha: 0.4,
    }, {
      backgroundColor: backgroundColor,
      alpha: 1,
      duration: 1,
    }, '<');

    /*
    gsap.matchMedia().add(`(max-width: 1023.99px)`, () => {
      gsap.timeline({
        scrollTrigger: {
          trigger: heroMediaContainer,
          start: `bottom bottom`,
          end: `bottom top`,
          scrub: true,
          // markers: true,
        }
      }).to(heroMediaContainer, {
        opacity: 0,
      })
    } )
    gsap.matchMedia().add(`(min-width: 1024px)`, () => {
      ScrollTrigger.create({
        trigger: heroBlock,
        endTrigger: '.hero-fade-out-trigger',
        start: 'top top',
        end: 'bottom bottom',
        pin: '.hero-pin-container',
        pinSpacing: 'margin',
        scrub: true,
        // markers: true,
      })

      ScrollTrigger.create({
        trigger: heroBlock,
        start: 'top top',
        end: 'bottom bottom',
        scrub: true,
        onUpdate: ({progress}) => {
          heroTextContainer.style.transform = `translateX(calc((-100% - 8vw) * ${progress}))`
          // heroMediaContainer.style.width = `calc((42vw + 24px) + (58vw - 24px) * ${progress})`
        },
        // markers: true,
      })

      gsap
        .timeline({
          scrollTrigger: {
            trigger: '.hero-fade-out-trigger',
            start: 'top bottom',
            end: 'bottom bottom',
            scrub: true,
            // markers: true,
          },
          onUpdate: () => {
            adjacentBlock.style.backgroundColor = 'rgba(0, 0, 0, 0)'
          },
          onComplete: () => {
            adjacentBlock.style.backgroundColor = backgroundColor
          },
        })
        .fromTo(
          '.hero-media-overlay',
          {
            backgroundColor: 'rgba(0, 0, 0, 0)',
          },
          {
            backgroundColor: backgroundColor,
          },
        )

      return () => {
        heroTextContainer.style.transform = ``
        heroMediaContainer.style.width = ``
        adjacentBlock.style.backgroundColor = ''
      }
    })
     */
  }

  // Video
  gsap
    .timeline({
      scrollTrigger: {
        trigger: '.video-container',
        start: () => `bottom-=${window.innerHeight}px bottom`,
        end: 'bottom bottom',
        scrub: true,
        // markers: true,
      },
    })
    .to('.video', {
      borderRadius: '0',
      scale: 1,
      opacity: 1,
    })

  if (allElementsExist('.block-parallaxHeroBlock', '.parallax-hero-video', '.parallax-hero-video-placeholder') ) {
    for (const parallaxHeroBlock of document.querySelectorAll('.block-parallaxHeroBlock')) {
      const blockViewHeight = 2.5
      const animationDuration = 0.9
      const stickyDuration = 1 - animationDuration

      const parallaxHeroOriginalVideo = document.querySelector('.parallax-hero-video')
      const parallaxHeroVideoPlaceholder = document.querySelector('.parallax-hero-video-placeholder')
      const parallaxHeroVideo = parallaxHeroOriginalVideo.cloneNode(true)
      parallaxHeroVideoPlaceholder.append(parallaxHeroVideo)

      gsap.set(parallaxHeroVideo, {
        width: () => parallaxHeroOriginalVideo.getBoundingClientRect().width,
        height: () => parallaxHeroOriginalVideo.getBoundingClientRect().height,
      })
      gsap
        .timeline({
          defaults: {
            ease: 'none',
          },
          scrollTrigger: {
            trigger: parallaxHeroBlock,
            start: 'top top',
            end: `bottom bottom`,
            scrub: true,
            invalidateOnRefresh: true,
            // markers: true
          },
        })
        .fromTo(
          parallaxHeroVideo,
          {
            width: () => parallaxHeroOriginalVideo.getBoundingClientRect().width,
            height: () => parallaxHeroOriginalVideo.getBoundingClientRect().height,
            x: () => parallaxHeroOriginalVideo.getBoundingClientRect().left + window.scrollX,
            y: () => parallaxHeroOriginalVideo.getBoundingClientRect().top + window.scrollY,
          },
          {
            width: () => window.innerWidth,
            height: () => window.innerHeight,
            x: 0,
            y: () =>
              parallaxHeroBlock.getBoundingClientRect().height -
              window.innerHeight -
              window.innerHeight * stickyDuration * (blockViewHeight - 1),
            duration: animationDuration,
          },
        )
        .to(parallaxHeroVideo, {
          y: () => parallaxHeroBlock.getBoundingClientRect().height - window.innerHeight,
          duration: stickyDuration,
        })
      parallaxHeroVideo.classList.add('z-10')
      parallaxHeroVideo.classList.remove('opacity-0')
    }
  }

  for (const propertiesElement of gsap.utils.toArray('.properties')) {
    const properties = gsap.utils.toArray('.property')
    gsap.matchMedia().add(`(min-width: 1024px)`, () => {
      for (const [index, propertyElement] of properties.entries()) {
        const accordionToggleElement = propertyElement.querySelector('.accordion-toggle')
        const startOffset = 20

        accordionToggleElement.addEventListener('click', (event) => {
          event.preventDefault()
          let offset = -startOffset
          for (const [i, propertyElement] of properties.entries()) {
            if (i < index) {
              offset += propertyElement.offsetHeight - 5 // Where does the magic number come from?
            }
          }
          scrollSmoother.scrollTo(propertiesElement, true, `top+=${offset}`)
        })

        const getSpacer = () => {
          const propertyBody = propertyElement.querySelector('.property-body')
          return Math.max(accordionToggleElement.offsetHeight, propertyBody.offsetTop - startOffset / 2) - 1
        }
        ScrollTrigger.create({
          trigger: propertyElement,
          start: `top-=${index * getSpacer()} top+=${startOffset}`,
          endTrigger: properties[properties.length - 1],
          end: `top+=48px top+=${properties.length * getSpacer() + startOffset / 2}`,
          pin: true,
          pinSpacing: false,
          invalidateOnRefresh: true,
          // markers: true
        })
      }
    });
  }
})

for (const animatedTextElement of gsap.utils.toArray('.animated-text fade-in-in-viewport')) {
  let animatedText = SplitText.create(animatedTextElement, {
    type: 'words,chars',
  })

  gsap.set(animatedText.chars, {
    opacity: 0,
    y: 30,
  })

  gsap
    .timeline({
      scrollTrigger: {
        trigger: animatedTextElement,
        start: 'top bottom',
        end: 'bottom top',
        once: true,
      },
    })
    .to(animatedText.chars, {
      duration: 0.5, // Length of the individual character fade
      opacity: 1,
      y: 0,
      // KEY CHANGE HERE:
      stagger: {
        amount: 0.5, // The total time to distribute the start of animations
        from: 'start',
      },
      ease: 'power3.out',
    })
}

$(document).ready(function () {
  const $button = $('.email-button')

  $button.on('click', function (event) {
    event.preventDefault()

    const $this = $(this)
    const emailToCopy = $this.data('email')

    const $wrap = $this.find('.label-wrap')
    const $hover = $this.find('.hover-content')
    const $copyLabel = $this.find('.copy-label')

    const originalLabelText = 'Kopier'

    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard
        .writeText(emailToCopy)
        .then(function () {
          $copyLabel.text('Kopiert!')

          gsap.set($wrap, {width: 'auto'})

          const newHoverWidth = $hover.outerWidth(true)

          gsap.set($wrap, {width: newHoverWidth})

          setTimeout(function () {
            if ($copyLabel.text() === 'Kopiert!') {
              $copyLabel.text(originalLabelText)

              const revertedHoverWidth = $hover.outerWidth(true)

              gsap.to($wrap, {
                width: revertedHoverWidth,
                duration: 0.3,
                ease: 'power2.out',
              })
            }
          }, 1500)
        })
        .catch((err) => {
          console.error('Could not copy text: ', err)
        })
    }
  })

  $button.on('mouseleave', function () {
    $button.find('.copy-label').text('Kopier')
  })

  $('.email-button').each(function () {
    const $btn = $(this)
    const $wrap = $btn.find('.label-wrap')
    const $default = $btn.find('.default-text')
    const $hover = $btn.find('.hover-content')

    function setDefaultWidth() {
      const defaultWidth = $default.outerWidth(true) + 12
      gsap.set($wrap, {width: defaultWidth})
    }

    setDefaultWidth()

    $(window).on('resize', setDefaultWidth)

    $btn.on('mouseenter', function () {
      const hoverWidth = $hover.outerWidth(true)

      gsap.to($wrap, {
        width: hoverWidth,
        duration: 0.3,
        ease: 'power2.out',
      })

      gsap.to($default, {
        opacity: 0,
        duration: 0.2,
        ease: 'power2.out',
      })

      gsap.to($hover, {
        opacity: 1,
        duration: 0.2,
        ease: 'power2.out',
        onStart() {
          $hover.css('pointer-events', 'auto')
        },
      })
    })

    $btn.on('mouseleave', function () {
      const defaultWidth = $default.outerWidth(true) + 12

      gsap.to($wrap, {
        width: defaultWidth,
        duration: 0.3,
        ease: 'power2.out',
      })

      gsap.to($default, {
        opacity: 1,
        duration: 0.2,
        ease: 'power2.out',
      })

      gsap.to($hover, {
        opacity: 0,
        duration: 0.2,
        ease: 'power2.out',
        onComplete() {
          $hover.css('pointer-events', 'none')
        },
      })
    })
  })
})
